/**
 * @generated SignedSource<<98c07c3038ae2238faff51328c39cbf2>>
 * @relayHash 3802c6a316b2a7f76fae5a6914ae5372
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 67bcc509cbc12319640bbfe5c71c93d9c479f58721ebda10840de2cb8202f877

import type { ConcreteRequest, Query } from 'relay-runtime';
export type gqlJiraJsmServicesSearchServicesByIdQuery$variables = {
  ids: ReadonlyArray<string>;
  propertyKeys: ReadonlyArray<string>;
};
export type gqlJiraJsmServicesSearchServicesByIdQuery$data = {
  readonly devOpsServicesById: ReadonlyArray<{
    readonly description: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly properties: AGG$JSON | null | undefined;
    readonly serviceTier: {
      readonly level: number;
    } | null | undefined;
  }> | null | undefined;
};
export type gqlJiraJsmServicesSearchServicesByIdQuery = {
  response: gqlJiraJsmServicesSearchServicesByIdQuery$data;
  variables: gqlJiraJsmServicesSearchServicesByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "propertyKeys"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "level"
},
v6 = {
  "args": [
    {
      "kind": "Variable",
      "name": "keys",
      "variableName": "propertyKeys"
    }
  ],
  "kind": "ScalarField",
  "name": "properties"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "DevOpsService",
        "kind": "LinkedField",
        "name": "devOpsServicesById",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "DevOpsServiceTier",
            "kind": "LinkedField",
            "name": "serviceTier",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "DevOpsService",
        "kind": "LinkedField",
        "name": "devOpsServicesById",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "DevOpsServiceTier",
            "kind": "LinkedField",
            "name": "serviceTier",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v2/*: any*/)
            ]
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "67bcc509cbc12319640bbfe5c71c93d9c479f58721ebda10840de2cb8202f877",
    "metadata": {},
    "name": "gqlJiraJsmServicesSearchServicesByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d536fa7bf1b35ed5337307d00fe95d1e";

export default node;
